export const SET_DATE_ACT = 'dateSelection';
export const SET_EMPRESA_ACTION = 'empresa';
export const SET_CENTRO_CUSTO_ACTION = 'centroCusto';
export const SET_PRODUTO_ACTION = 'produto';
export const SET_PROJETO_ACTION = 'projeto';
export const SET_RESPONSAVEL_ACTION = 'responsavel';
export const SET_GRUPO_ACTION = 'grupo';
export const SET_FORNECEDOR_ACTION = 'fornecedor';
export const SET_SOLICITANTE_ACTION = 'solicitante';
